import { wareHouseReceiptsTypes } from './actionTypes';

export const getList = (payload: any) => ({
  type: wareHouseReceiptsTypes.GET_WAREHOUSERECEIPTS,
  payload,
});

export const getListSuccess = (payload: any) => ({
  type: wareHouseReceiptsTypes.GET_WAREHOUSERECEIPTS_SUCCESS,
  payload,
});

export const getListFail = (error: any) => ({
  type: wareHouseReceiptsTypes.GET_WAREHOUSERECEIPTS_FAIL,
  payload: error,
});

export const getMilestoneConfigWR = (payload?: any)=>{
  return{
    type: wareHouseReceiptsTypes.GET_MILESTONESCONFIG_WR,
    payload,
  }
}

export const getMilestoneConfigWRSuccess = (payload:any)=>{
  return{
    type: wareHouseReceiptsTypes.GET_MILESTONESCONFIG_WR_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigWRFail = (payload:any)=>{
  return{
    type: wareHouseReceiptsTypes.GET_MILESTONESCONFIG_WR_FAIL,
    payload,
  }
}
